import { twMerge } from "tailwind-merge";
import { useAppSelector } from "../../../hooks/redux";
import { FlexCol } from "../../../utils/flexLayouts";
import { selectCurrentUser } from "src/modules/users/selector";
import { SelectedCurrentUser } from "src/modules/users/types";
import { useEffect, useState } from "react";
import { getUserProperties } from "src/modules/users/api";
import { usePersonalAvatar } from "src/hooks/usePersonalAvatar";

const Avatar = () => {
  const currentUser: SelectedCurrentUser = useAppSelector(selectCurrentUser);

  const { avatar, shortName, displayName, email } = currentUser;

  return (
    <div
      className={twMerge(
        !avatar ? "bg-darkblue" : "bg-slate-500",
        "hidden sm:flex items-center justify-center w-10 h-10 overflow-hidden rounded-full ring-1 ring-white max-md:h-6 max-md:w-6 max-sm:h-10 max-sm:w-10"
      )}
    >
      {email && avatar && (
        <img
          className="block object-cover w-full h-full max-w-full"
          src={avatar}
          alt={displayName}
        />
      )}
      {!email && shortName && (
        <FlexCol className="font-medium max-sm:text-[10px] text-white select-none">
          {shortName}
        </FlexCol>
      )}
    </div>
  );
};

export default Avatar;

type Props = {
  avatar: string | null;
  shortName: string;
  displayName: string;
  email: string;
  className?: string;
  classNameText?: string;
};

export const UserAvatar = (props: Props) => {
  const { avatar, shortName, displayName, email, className, classNameText } =
    props;

  return (
    <div
      className={twMerge(
        !avatar ? "bg-darkblue" : "bg-slate-500",
        "flex overflow-hidden justify-center items-center w-6 h-6 rounded-full ring-1 ring-white min-w-[24px] min-h-[24px] max-sm:h-6 max-sm:w-6",
        className
      )}
    >
      {avatar ? (
        <img
          className="block object-cover w-full h-full max-w-full"
          src={avatar}
          alt={displayName}
        />
      ) : (
        <FlexCol
          className={twMerge(
            "font-medium text-[12px] max-sm:text-[10px] text-white select-none",
            classNameText
          )}
        >
          {shortName}
        </FlexCol>
      )}
    </div>
  );
};

type Props2 = {
  shortName: string;
  displayName: string;
  email?: string;
  className?: string;
  classNameText?: string;
  single?: boolean;
  image?: string | null;
};

export const UserAvatar2 = (props: Props2) => {
  const {
    shortName,
    displayName,
    email,
    className,
    classNameText,
    single = false,
  } = props;

  const { image, loadingImage } = usePersonalAvatar(email);

  return (
    <>
      <div
        className={twMerge(
          !image ? "bg-darkblue" : "",
          "flex overflow-hidden justify-center items-center w-6 h-6 rounded-full ring-1 ring-white max-sm:h-6 max-sm:w-6 shrink-0",
          className
        )}
      >
        {!loadingImage && image ? (
          <img
            className="block object-cover w-full h-full max-w-full"
            src={image}
            alt={displayName}
          />
        ) : (
          <FlexCol
            className={twMerge(
              "font-medium text-[12px] max-sm:text-[10px] text-white select-none",
              classNameText
            )}
          >
            {shortName.toUpperCase()}
          </FlexCol>
        )}
      </div>
      {single && (
        <FlexCol className={twMerge("ml-2", classNameText)}>
          {displayName}
        </FlexCol>
      )}
    </>
  );
};

export const UserAvatarStore = (props: Props2) => {
  const {
    shortName,
    displayName,
    image,
    className,
    classNameText,
    single = false,
  } = props;

  return (
    <>
      <div
        className={twMerge(
          !image ? "bg-darkblue" : "",
          "flex overflow-hidden justify-center items-center w-4 h-4 tablet:w-6 tablet:h-6 rounded-full ring-1 ring-white shrink-0",
          className
        )}
      >
        {image ? (
          <img
            className="block object-cover w-full h-full max-w-full"
            src={image}
            alt={displayName}
          />
        ) : (
          <FlexCol
            className={twMerge(
              "font-medium text-[12px] max-sm:text-[10px] text-white select-none",
              classNameText
            )}
          >
            {shortName.toUpperCase()}
          </FlexCol>
        )}
      </div>
      {single && (
        <FlexCol className={twMerge("ml-2", classNameText)}>
          {displayName}
        </FlexCol>
      )}
    </>
  );
};
